import { render, staticRenderFns } from "./wjsTab.vue?vue&type=template&id=ca8b7d62&scoped=true&"
import script from "./wjsTab.vue?vue&type=script&lang=js&"
export * from "./wjsTab.vue?vue&type=script&lang=js&"
import style0 from "./wjsTab.vue?vue&type=style&index=0&id=ca8b7d62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8b7d62",
  null
  
)

export default component.exports